import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";

const getWorkspaceKey = async (workspaceId: string) => {
  const { data, error } = await supabase.from("workspace_keys").select("*").eq("workspace_id", workspaceId);

  if (error) {
    throw error;
  }

  return data;
};

export const useWorkspaceKeys = (workspaceId: string) => {
  return useQuery({
    queryKey: ["workspace_keys", workspaceId],
    queryFn: () => getWorkspaceKey(workspaceId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
